import { Link } from "react-router-dom";

export const LAST_UPDATED = new Date("2026-08-20T00:00:00Z").toLocaleDateString("en-GB", {
  day: "numeric",
  month: "long",
  year: "numeric",
});

export const LegalHero = ({ eyebrow, title, intro, testId }) => (
  <section className="border-b border-[#DFE6ED] bg-[#102A43]" data-testid={testId}>
    <div className="mx-auto max-w-[900px] px-5 py-14 lg:py-20">
      <p className="text-[10px] font-semibold uppercase tracking-[0.22em] text-[#D9A441]">
        {eyebrow}
      </p>
      <h1 className="mt-4 font-display text-3xl font-black leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">
        {title}
      </h1>
      <p className="mt-5 max-w-2xl text-sm leading-relaxed text-[#bcccdc] md:text-base">{intro}</p>
      <p className="mt-6 text-xs text-[#829ab1]">Last updated: {LAST_UPDATED}</p>
    </div>
  </section>
);

export const DraftNotice = () => (
  <div
    data-testid="legal-draft-notice"
    className="rounded-[12px] border-l-4 border-[#D9A441] bg-[#FDF6E7] px-5 py-4"
  >
    <p className="font-display text-sm font-bold text-[#7A5A12]">
      Draft — pending legal review
    </p>
    <p className="mt-2 text-sm leading-relaxed text-[#7A5A12]">
      This document has been drafted specifically for the ADIT Connect platform and its current
      functionality. It is <strong>not yet legal advice and is not a final instrument</strong>. It
      must be reviewed, amended and approved by qualified UAE legal counsel before commercial
      launch. Sections marked <em>[for counsel]</em> require a decision from your lawyers.
    </p>
  </div>
);

export const Clause = ({ n, title, children }) => (
  <section className="scroll-mt-24 border-t border-[#DFE6ED] pt-8" id={`clause-${n}`}>
    <h2 className="font-display text-base font-bold text-[#102A43] md:text-lg">
      <span className="mr-2 text-[#147D78]">{n}.</span>
      {title}
    </h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-[#48606F]">{children}</div>
  </section>
);

export const Bullets = ({ items }) => (
  <ul className="ml-1 space-y-2">
    {items.map((item) => (
      <li key={item} className="flex gap-2.5">
        <span aria-hidden className="mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-[#147D78]" />
        <span>{item}</span>
      </li>
    ))}
  </ul>
);

export const LegalFooterNav = ({ current }) => {
  const links = [
    ["/terms", "Terms of Service"],
    ["/privacy", "Privacy Policy"],
    ["/faqs", "FAQs"],
    ["/get-help", "Contact / Support"],
  ].filter(([to]) => to !== current);
  return (
    <div className="mt-12 border-t border-[#DFE6ED] pt-6">
      <p className="text-[10px] font-semibold uppercase tracking-[0.15em] text-[#8899A8]">
        Also in Legal &amp; Support
      </p>
      <div className="mt-3 flex flex-wrap gap-x-6 gap-y-2 text-sm">
        {links.map(([to, label]) => (
          <Link key={to} to={to} className="font-medium text-[#147D78] hover:underline">
            {label}
          </Link>
        ))}
      </div>
    </div>
  );
};
